var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Icons",
    x: -512,
    y: -128,
    width: 1280,
    height: 800,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons1"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Strike"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "H1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "H2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "H3"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "list-ul"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "hamburger-1"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "hamburger-2"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "list-ol"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "list-task"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "trash"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "vertical-menu"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "horizontal-menu"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "sidebar-2"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Pen"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Pen1"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "clock"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "external-link"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "hr"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "info"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "warning"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "plus-circle"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "minus-circle"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.595,11.204l8.91,0l5.536,9.391l5.591,-9.391l8.831,0l-14.422,25.359l-14.446,-25.359Z",
    style: {
      fill: "#435466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.089,11.204l23.952,41.845l24.126,-41.845l-9.704,0l-14.422,25.359l-14.446,-25.359l-9.506,0Z",
    style: {
      fill: "#4dba87"
    }
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "cog"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "radio-check"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "eye-slash"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "eye"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "toggle-off"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "shredder"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "spinner--loading--dots-"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "react"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "check-selected"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "turn-off"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "code-block"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "user"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "coffee-bean"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "coffee-beans"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coffee-bean1"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "coffee-bean-filled"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "coffee-beans-filled"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coffee-bean2"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard-paste"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard-copy"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Layer1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVue);
export default __webpack_public_path__ + "static/media/vue.fb5f39af82f7145c367ecec801a4c528.svg";
export { ForwardRef as ReactComponent };